export const isDev = import.meta.env.DEV;
export const usesFirebaseEmulator =
  import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true";
export const isProduction = () => window.location.hostname === "app.reedy.ai";

export const isHeadlessBrowser = (): boolean =>
  typeof navigator !== "undefined" &&
  (/Headless(Chrome|Firefox)/i.test(navigator.userAgent) ||
    navigator.webdriver === true);
